import script from "./page.vue?vue&type=script&setup=true&lang=js"
export * from "./page.vue?vue&type=script&setup=true&lang=js"

import "./page.vue?vue&type=style&index=0&id=7db078d7&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db078d7"]])

export default __exports__